import { render, staticRenderFns } from "./reason.vue?vue&type=template&id=cd5fe522&scoped=true"
import script from "./reason.vue?vue&type=script&lang=js"
export * from "./reason.vue?vue&type=script&lang=js"
import style0 from "./reason.vue?vue&type=style&index=0&id=cd5fe522&prod&lang=css"
import style1 from "./reason.vue?vue&type=style&index=1&id=cd5fe522&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd5fe522",
  null
  
)

export default component.exports